import script from "./TressCheckoutDeliveryForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressCheckoutDeliveryForm.vue?vue&type=script&lang=ts&setup=true"

import "./TressCheckoutDeliveryForm.vue?vue&type=style&index=0&id=2f701d5d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f701d5d"]])

export default __exports__